<mat-dialog-content>

  @if (data=='perfil') {
    <h1 style='text-align: center;'>Editar Perfil</h1>
  }
  @if (data=='contrasena') {
    <h1 style='text-align: center;'>Cambiar contraseña</h1>
  }
  @if (data=='foto') {
    <h1 style='text-align: center;'>Cambiar foto</h1>
  }

  @if (data=='perfil') {
    <form [formGroup]="formProfile"
      (ngSubmit)="formProfile.valid?save(formProfile.value):errorMessage()">
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input autocomplete="off" type="text" formControlName='name' matInput placeholder="Nombre">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Dirección</mat-label>
        <input autocomplete="off" type="text" formControlName='address' matInput placeholder="Dirección">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Teléfono</mat-label>
        <input autocomplete="off" type="number" formControlName='phone' matInput placeholder="Telefono">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Correo</mat-label>
        <input autocomplete="off" type="text" formControlName='email' matInput placeholder="Correo">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Contacto emergencia</mat-label>
        <input autocomplete="off" type="text" formControlName='emergencyContact' matInput
          placeholder="Contacto emergencia">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Teléfono contacto emergencia</mat-label>
        <input autocomplete="off" type="number" formControlName='emergencyContactPhone' matInput
          placeholder="Telefono contacto emergencia">
      </mat-form-field>
      <mat-form-field [appOpenDatepickerOnClick]="pickerEntry">
        <mat-label>Fecha ingreso</mat-label>
        <input matInput [matDatepicker]="pickerEntry" autocomplete="off" matInput formControlName='dateJoining'
          required>
        <mat-datepicker-toggle matIconSuffix [for]="pickerEntry">
        </mat-datepicker-toggle>
        <mat-datepicker #pickerEntry [touchUi]='movil?true:false'></mat-datepicker>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="primary" class="button-save mat-elevation-z5" mat-raised-button type="submit">Guardar</button>
    </form>
  }

  @if (data=='foto') {
    <form [formGroup]="formPhoto"
      (ngSubmit)="formPhoto.valid?save(formPhoto.value):errorMessage()">
      <div style="display:flex; flex-direction:column; align-items: center; justify-content:center;">
        <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
        <file-input style="width: 100%;" [params]='fileInput' (fileSave)='fileChange($event)'></file-input>
        <button color="primary" class="button-save mat-elevation-z5" mat-raised-button
        type="submit">Guardar</button>
      </div>
    </form>
  }

  @if (data=='contrasena') {
    <form [formGroup]="formPassword"
      (ngSubmit)="formPassword.valid?save(formPassword.value):errorMessage()">
      <mat-form-field>
        <mat-label>Contraseña anterior</mat-label>
        <input autocomplete="off" [type]="hide ? 'password' : 'text'" #old formControlName='passwordPrevious'
          required matInput placeholder="Contraseña anterior">
        <div class="hide-button" mat-icon-button matIconSuffix (click)="hide = !hide"
          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </div>
        <mat-hint align="end">{{old.value.length}}</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nueva contraseña</mat-label>
        <input autocomplete="off" [type]="hideOld ? 'password' : 'text'"
          (keyup)="change($event.target['value'], 'nueva')" #seguridad formControlName='password' required matInput
          placeholder="Nueva contraseña">
        <div class="hide-button" mat-icon-button matIconSuffix (click)="hideOld = !hideOld"
          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideOld">
          <mat-icon>{{hideOld ? 'visibility_off' : 'visibility'}}</mat-icon>
        </div>
        @if (seguridad.value.length<4 && seguridad.value.length>0) {
          <mat-hint style="color: red;"
            align="start"><strong>Contraseña poco segura</strong></mat-hint>
          }
          @if (seguridad.value.length<8 && seguridad.value.length>=4 ) {
            <mat-hint style="color: rgb(57, 139, 153);"
              align="start"><strong>Contraseña segura</strong></mat-hint>
            }
            @if (seguridad.value.length>=8) {
              <mat-hint style="color: green" align="start"><strong>contraseña muy
              segura</strong></mat-hint>
            }
            <mat-hint align="end">{{seguridad.value.length}}</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Confirmar nueva contraseña</mat-label>
            <input autocomplete="off" [type]="hideNew ? 'password' : 'text'"
              (keyup)="change($event.target['value'], 'confim')" #seguridad2 matInput required #test
              formControlName='confirmPassword' placeholder="Confirmar nueva contraseña">
            <div class="hide-button" mat-icon-button matIconSuffix (click)="hideNew = !hideNew"
              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNew">
              <mat-icon>{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
            @if (ok==false && seguridad2.value.length>0) {
              <mat-hint align="start"
                style="color: red;"><strong>Contraseña incorrecta</strong></mat-hint>
              }
              @if (ok==true  && seguridad2.value.length>0) {
                <mat-hint align="start"
                  style="color: green;"><strong>Contraseña correcta</strong></mat-hint>
                }
                <mat-hint align="end">{{seguridad2.value.length}}</mat-hint>
              </mat-form-field>
              <button color="primary" class="button-save mat-elevation-z5" mat-raised-button type="submit">Guardar</button>
            </form>
          }

        </mat-dialog-content>